export const en = {
  tryAgain: 'Try again',
  taskNotSent: 'Task not sent.',
  why: 'Why?',
  couldntSend: 'Task could not be sent',
  errorTitle: 'Error details'
};

export type Translations = typeof en;
